var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1570_1056)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.00693 0C4.19739 0 0.29834 3.89905 0.29834 8.70859C0.29834 10.6396 0.927166 12.4237 1.99104 13.8678L5.22961 10.6292C4.93593 10.0528 4.77027 9.39992 4.77027 8.70859C4.77027 6.36851 6.66712 4.47165 9.0072 4.47165C11.3473 4.47165 13.2441 6.36851 13.2441 8.70859C13.2441 11.0487 11.3473 12.9455 9.0072 12.9455C8.35463 12.9455 7.73645 12.7979 7.18432 12.5342L3.93238 15.7862C5.36143 16.8126 7.11363 17.4172 9.0072 17.4172C13.8167 17.4172 17.7158 13.5181 17.7158 8.70859C17.7158 3.89905 13.8167 0 9.00693 0Z",
    fill: "#EDAD4D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1570_1056"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.4175,
    height: 17.4175,
    fill: "white",
    transform: "translate(0.29834)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle);
export default __webpack_public_path__ + "static/media/Circle.b82f26d345e22f3869fc7dc973e67ff5.svg";
export { ForwardRef as ReactComponent };